import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import Moment from "react-moment";
import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import { setAlert } from "../../../../action/alert";
import Alert from "../../../layout/Alert";
import "./DeviceDACLogs.css";
import AppButton from "../../../Common/Button/Button";
import FormInput from "../../../Common/FormInputs/MuiTextField";
import DataTable from "../../../Common/DataTable/DataTable";
import { format } from "date-fns";
import { dacStatsPageSize } from "../DACStatisticsConstants";


const DeviceDACLogs = ({
    deviceDetails,
    dacData = [],
    getDeviceDACLogsData,
    showSearch = false,
    showCount = false
}) => {

    const [deviceDACLogsData, setDeviceDACLogsData] = useState([]);
    const [updateFlag, setUpdateFlag] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [macAddress, setMacAddress] = useState("");

    const headers = {
        serialNumber: "S.No",
        timestamp: 'Created At'
    };

    // useEffect(() => {
    //     filter()
    // }, [])

    useEffect(() => {
        if (deviceDetails && deviceDetails instanceof Object && deviceDetails.hasOwnProperty('macAddress')) {
            getDeviceDACLogs()
        }
    }, [deviceDetails])

    useEffect(() => {
        if (updateFlag) {
            getDeviceDACLogs()
        }
    }, [updateFlag])

    useEffect(() => {
        setDeviceDACLogsData(dacData)
    }, [dacData])

    const filter = () => {
        setUpdateFlag(Math.random());
    }

    const getNextPage = () => {
        const newPg = pageIndex + 1
        setPageIndex(newPg);
        setIsLoading(true)
        getDeviceDACLogsData({
            macAddress,
            //pagination not yet implemented in API, check if param names are correct after implementation
            pgIndex: newPg,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }

    const getPrevPage = () => {
        const newPg = pageIndex - 1;
        setPageIndex(newPg);
        setIsLoading(true)
        getDeviceDACLogsData({
            macAddress,
            //pagination not yet implemented in API, check if param names are correct after implementation
            pgIndex: newPg,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }
    const getDeviceDACLogs = () => {
        setIsLoading(true)
        getDeviceDACLogsData({ macAddress: deviceDetails?.macAddress ?? "" }, () => {
            setIsLoading(false);
        })
    }

    const searchDACLogs = () => {
        setIsLoading(true)
        setPageIndex(0);
        getDeviceDACLogsData({
            macAddress,
            //pagination not yet implemented in API, check if param names are correct after implementation
            pgIndex: 0,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }

    const deviceDACLogColumns = Object.keys(headers).map((key) => ({
        key,
        label: headers[key],
        minWidth: key === "timestamp" ? 220 : 100,
        render: (value) => (
            <Box className={String(value || "").length > 200 ? "breakWord" : ""}>
                {value}
            </Box>
        )
    }));

    const deviceDACLogRows = (deviceDACLogsData || []).map((element, index) => ({
        rowId: `${element}-${index}`,
        serialNumber: index + 1,
        timestamp: format(new Date(Number(element)), "dd MMM yyyy, hh:mm a")
    }));

    return (
        <Fragment>
            {showSearch && (
                <Box className="content-block bottom-shadow dac-logs-filter">
                    <Box className="py-15 dac-logs-filter-row">
                        <FormInput
                            type="text"
                            size="small"
                            placeholder="Enter MAC address"
                            value={macAddress}
                            onChange={(e) => setMacAddress(e.target.value)}
                            startAdornment={<SearchIcon />}
                            className="dac-logs-filter-input"
                        />
                        <AppButton
                            variant="primary"
                            size="medium"
                            onClick={() => searchDACLogs()}
                            disabled={macAddress === ""}
                            className="dac-logs-filter-btn"
                        >
                            Filter
                        </AppButton>
                    </Box>
                </Box>
            )}
            <Alert />

            {isLoading ?
                <div
                    style={{
                        display: "grid",
                        placeItems: "center",
                        height: "80vh",
                    }}
                >
                    <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
                </div>
                :
                <div>
                    {showCount && (
                        <Box className="content-block bottom-shadow dac-logs-count-block">
                            <Box className="page-title dac-logs-count-title">
                                <Box component="h3" sx={{ m: 0 }}>{`DAC Count : ${dacData?.length || "-"}`}</Box>
                            </Box>
                        </Box>
                    )}
                    <Box className="content-block bottom-shadow py-15 mb-30">
                        <Grid2 container>
                            <Grid2 size={12}>
                                <Box className="table-wrapper mb-20" sx={{ maxHeight: "unset" }}>
                                    <DataTable
                                        columns={deviceDACLogColumns}
                                        data={deviceDACLogRows}
                                        rowKey="rowId"
                                        minWidth="100%"
                                        msgForDisplay="No Data found"
                                        sx={{ overflowX: "hidden" }}
                                        tableContainerSx={{ width: "100%" }}
                                    />
                                </Box>
                                {/* uncomment for pagination
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <button
                                        className="btn btn-style-2 orange-bg"
                                        style={{ marginRight: "12px" }}
                                        onClick={() => getPrevPage()}
                                        disabled={pageIndex === 0}
                                    >
                                        Previous
                                    </button>
                                    <button
                                        className="btn btn-style-2 orange-bg"
                                        onClick={() => getNextPage()}
                                        disabled={dacData?.length < dacStatsPageSize}
                                    >
                                        Next
                                    </button>
                                </div> */}
                            </Grid2>
                        </Grid2>
                    </Box>
                </div>
            }
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
    setCustomAlert: (message, alertType) => dispatch(setAlert(message, alertType))
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDACLogs);
